import { get, put } from "@beatbox/voice-core";
import { store } from "../app/state/store.js";
const KEY = "a11y";
export async function loadPrefs() {
    const saved = await get("prefs", KEY);
    if (saved)
        store.a11y.set(saved);
}
export async function setPref(key, value) {
    store.a11y.update((p) => ({ ...p, [key]: value }));
    await put("prefs", KEY, store.a11y.get());
}
